import React from "react";

export default function CommentBox({ value }) {
  return (
    <>
      {value && (
        <>
          <div className="leadComemntrow">
            <div className="userimagebox">
              <div className="userimgnamebox">
                <span className="thumb mx-0">
                  <img
                    src={
                      value.userimage
                        ? value.userimage
                        : "../images/blankUser.png"
                    }
                    alt=""
                    style={{
                      borderRadius: "50%",
                      height: "40px",
                      width: "40px",
                    }}
                  />
                </span>
                <div className="usernamebox">
                  <h6>{value.username}</h6>
                  <span className="whycomment px-1">({value.role})</span>
                  {/* <p>{value.useremail}</p> */}
                </div>
              </div>
              <div className="commentDatatime">
                <p className="CommnetDate">
                  {" "}
                  {value.commentdate.split(" ")[0]}
                </p>
              </div>
            </div>
            <div className="commentdecs">
              <p
                dangerouslySetInnerHTML={{
                  __html: value.comment,
                }}
              ></p>
            </div>
          </div>
        </>
      )}
    </>
  );
}
